'use client'
import {
  Tag,
  TagCloseButton,
  TagLabel,
  TagLeftIcon,
  TagRightIcon,
  useTagStyles
} from "./chunk-RPO2WXNL.mjs";
export {
  Tag,
  TagCloseButton,
  TagLabel,
  TagLeftIcon,
  TagRightIcon,
  useTagStyles
};
//# sourceMappingURL=index.mjs.map